import React from 'react';

const TouchUpPreferences = ({ groomingBookingData, setGroomingBookingData }) => {
  const options = groomingBookingData && groomingBookingData.groomingOptions ? groomingBookingData.groomingOptions : {};
  const selectedAdditional = options.additionalServices || [];

  const toggleAdditionalService = (service) => {
    let updated = selectedAdditional.slice(0);

    const exists = updated.indexOf(service) >= 0;
    if (exists) {
      // remove
      const idx = updated.indexOf(service);
      if (idx >= 0) {
        updated.splice(idx, 1);
      }
    } else {
      // add
      updated.push(service);
    }

    setGroomingBookingData(function (prev) {
      const prevOpts = prev.groomingOptions || {};
      return {
        ...prev,
        groomingOptions: {
          ...prevOpts,
          additionalServices: updated
        }
      };
    });
  };

    const handleSpecialConditionChange = (condition) => {
        setGroomingBookingData((prevData) => ({
            ...prevData,
            groomingOptions: {
                ...prevData.groomingOptions,
                [condition]: !prevData.groomingOptions[condition],
            },
        }));
    };

  const isSelected = (service) => selectedAdditional.indexOf(service) >= 0;
  const isConditionSelected = (condition) => groomingBookingData.groomingOptions[condition];

  // These are included in Touch‑Up by default
  const included = [
    'Face Trim',
    'Feet Tidy / Pad Shave',
    'Sanitary Trim',
    'Nail Trim & File',
    'Anal Glands Expression',
    'Bath & Blow Dry',
    'Brush Out',
    'Ear Cleaning',
    'Paw Balm'
  ];

  // Offered add‑ons (exclude items already included above)
  // keys are internal values; labels are customer-facing
  const addOns = [
    { key: 'deshedding', label: 'De‑Shedding Treatment' },
    { key: 'fleaTick', label: 'Flea & Tick Treatment' },
    { key: 'teethBrushing', label: 'Teeth Brushing' },
  ];

  return (
    <div className="touchup-preferences">
      <h3>What’s included in Touch‑Up?</h3>
      <ul>
        {included.map(function (item, i) {
          return <li key={i}>{item}</li>;
        })}
      </ul>

    <h3>Special Conditions</h3>
    <div className="special-conditions">
        <button
            className={`condition-button ${isConditionSelected('mattedHair') ? 'selected' : ''}`}
            onClick={() => handleSpecialConditionChange('mattedHair')}
        >
            Matted Hair (De-matting)
        </button>
        <button
            className={`condition-button ${isConditionSelected('skunkTreatment') ? 'selected' : ''}`}
            onClick={() => handleSpecialConditionChange('skunkTreatment')}
        >
            Skunk Treatment (Exotic Odor)
        </button>
    </div>

      <h3>Additional Services</h3>
      <div className="additional-services">
        {addOns.map(function (a) {
          return (
            <button
              key={a.key}
              className={'service-button ' + (isSelected(a.key) ? 'selected' : '')}
              onClick={function () { toggleAdditionalService(a.key); }}
              type="button"
            >
              {a.label}
            </button>
          );
        })}
      </div>

    </div>
  );
};

export default TouchUpPreferences;
